<template>
    <div class="news">
        <siteHeader />
        <img src="@/assets/01.jpg" alt="main image" class="main-image">
        <div class="news-container">
            <div class="news-intro-card">
                <h2 class="card-title">兰台研读 <span class="english-subtitle">Archives Research</span></h2>
                <div class="news-content-area">
                    <div class="news-sidebar">
                        <ul>
                            <li v-for="category in categories" :key="category.type" @click="fetchVolumes(category.type)"
                                :class="{ active: selectedCategory === category.type }">
                                {{ category.name }}
                            </li>
                        </ul>
                    </div>
                    <div class="news-content">
                        <!-- Teaching Plan Table -->
                        <div v-if="selectedCategoryName === '教学计划' && teachingPlanList.length > 0">
                            <table class="teaching-plan-table">
                                <thead>
                                    <tr>
                                        <th>班期</th> 
                                        <th>课时</th>
                                        <th>上课时间</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in teachingPlanList" :key="item.id">
                                        <td>{{ item.schedule }}</td>
                                        <td>{{ item.classSpecifications }}</td>
                                        <td>{{ item.schooltime }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <p v-else-if="selectedCategoryName === '教学计划' && teachingPlanList.length === 0">暂无教学计划内容</p>

                        <!-- Course Planning Sections -->
                        <div v-if="selectedCategoryName === '课程规划'">

                            <!-- 20学时课程介绍 -->
                            <div v-if="coursePlanningList20.length > 0">
                                <h4>20学时课程介绍</h4>
                                <table class="course-planning-table">
                                    <thead>
                                        <tr>
                                            <th>课程名称</th>
                                            <th>课程内容</th>
                                            <th>课程时间</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in coursePlanningList20" :key="item.id">
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.introduce }}</td>
                                            <td>{{ item.classTime }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- 40学时课程介绍 -->
                            <div v-if="coursePlanningList40.length > 0">
                                <h4>40学时课程介绍</h4>
                                <table class="course-planning-table">
                                    <thead>
                                        <tr>
                                            <th>课程名称</th>
                                            <th>课程内容</th>
                                            <th>课程时间</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in coursePlanningList40" :key="item.id">
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.introduce }}</td>
                                            <td>{{ item.classTime }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <!-- 60学时课程介绍 -->
                            <div v-if="coursePlanningList60.length > 0">
                                <h4>60学时课程介绍</h4>
                                <table class="course-planning-table">
                                    <thead>
                                        <tr>
                                            <th>课程名称</th>
                                            <th>课程内容</th>
                                            <th>课程时间</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="item in coursePlanningList60" :key="item.id">
                                            <td>{{ item.name }}</td>
                                            <td>{{ item.introduce }}</td>
                                            <td>{{ item.classTime }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p
                                v-if="coursePlanningList20.length === 0 && coursePlanningList40.length === 0 && coursePlanningList60.length === 0">
                                暂无课程规划内容</p>
                        </div>
                        <!-- Course Video List -->
                        <div v-else-if="selectedCategoryName === '课 程' && courseVideoList.length > 0">
                            <div class="course-video-grid">
                                <el-tooltip class="video-item-tooltip" 
                                    v-for="video in courseVideoList" :key="video.id"
                                    content="可试看30秒" 
                                    placement="top"
                                    effect="dark">
                                    <div class="video-item" @click="viewCourseVideoDetail(video)">
                                        <img :src="video.imageUrl || 'https://exam.cqtcxy.com/prod-api/profile/upload/2026/03/17/档案收集 整理 鉴定基础知识 -档案整理的概述-第4点档案整理工作的基本原则-封面_20260317102449A012.jpg'" alt="Video Image" class="video-image">
                                        <div class="video-info">
                                            <h4 class="video-title">{{ video.name }}</h4>
                                        </div>
                                    </div>
                                </el-tooltip>
                            </div>
                        </div>
                        <p v-else-if="selectedCategoryName === '课 程' && courseVideoList.length === 0">暂无课程内容</p>

                        <!-- Expert List -->
                        <div v-else-if="selectedCategoryName === '专 家' && expertList.length > 0">
                            <div class="expert-faculty-grid">
                                <div class="item" v-for="expert in expertList" :key="expert.id"
                                    @click="viewExpertDetail(expert, 'expert')">
                                    <img :src="expert.photograph" alt="Expert Image" class="item-image">
                                    <div class="item-info">
                                        <h4 class="item-title">{{ expert.name }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p v-else-if="selectedCategoryName === '专 家' && expertList.length === 0">暂无专家信息</p>

                        <!-- Faculty List -->
                        <div v-else-if="selectedCategoryName === '师 资' && facultyList.length > 0">
                            <div class="expert-faculty-grid">
                                <div class="item" v-for="faculty in facultyList" :key="faculty.id"
                                    @click="viewExpertDetail(faculty, 'faculty')">
                                    <img :src="faculty.photograph" alt="Faculty Image" class="item-image">
                                    <div class="item-info">
                                        <h4 class="item-title">{{ faculty.name }}</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p v-else-if="selectedCategoryName === '师 资' && facultyList.length === 0">暂无师资信息</p>

                        <!-- Article Grid (Existing) -->
                        <div v-else>
                            <div class="article-grid">
                                <div class="article-item" v-for="article in volumeList" :key="article.id"
                                    @click="viewVolumeDetail(article)">
                                    <img :src="article.cover" alt="Article Image" class="article-image">
                                    <div class="article-info">
                                        <p class="article-date">{{ article.itemTime }}</p>
                                        <h4 class="article-title">{{ article.title }}</h4>
                                    </div>
                                </div>
                            </div>
                            <p v-if="!volumeList || volumeList.length === 0"></p>

                            <div class="pagination">
                                <button @click="goToPage(currentPage - 1)"
                                    :disabled="currentPage === 1">Previous</button>
                                <button v-for="page in totalPages" :key="page" @click="goToPage(page)"
                                    :class="{ active: currentPage === page }">
                                    {{ page }}
                                </button>
                                <button @click="goToPage(currentPage + 1)"
                                    :disabled="currentPage === totalPages">Next</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <siteFooter />

        <!-- Auth Dialog -->
        <AuthDialog 
            :visible.sync="showAuthDialog" 
            initial-mode="login"
            @login-success="handleLoginSuccess"
        />
    </div>
</template>

<script>
import siteHeader from '../components/SiteHeader.vue'
import siteFooter from '../components/SiteFooter.vue'
import AuthDialog from '../components/AuthDialog.vue'
import { getProjectList, getTeachingProgram, getCoursePlanningDalist, getSpecialist, getTeachers } from '@/api/website'
import { getMaterialList as getMaterialListAPI } from '@/api/course'

export default {
    name: 'VolumePage',
    components: {
        siteHeader,
        siteFooter,
        AuthDialog
    },
    data() {
        return {
            categories: [
                { name: '教学计划', type: '1' },
                { name: '课程规划', type: '2' },
                { name: '课 程', type: '3' },
                { name: '专 家', type: '4' },
                { name: '师 资', type: '5' }
            ],
            selectedCategory: '1',
            volumeList: [],
            teachingPlanList: [],
            coursePlanningList20: [],
            coursePlanningList40: [],
            coursePlanningList60: [],
            courseVideoList: [],
            expertList: [],
            facultyList: [],
            selectedCategoryName: '兰台研读',
            currentPage: 1,
            itemsPerPage: 6,
            totalItems: 0,
            showAuthDialog: false,
        };
    },
    mounted() {
        // 检查URL中是否有category参数
        const category = this.$route.query.category;
        if (category) {
            this.fetchVolumes(category);
        } else {
            this.fetchVolumes(this.selectedCategory, this.currentPage);
        }
    },
    watch: {
        '$route.query.category': {
            handler(newCategory) {
                if (newCategory) {
                    this.fetchVolumes(newCategory);
                }
            },
            immediate: true
        }
    },
    methods: {
        async fetchVolumes(type, pageNum = 1) {
            this.selectedCategory = type;
            this.currentPage = pageNum;
            const selectedCat = this.categories.find(cat => cat.type === type);
            this.selectedCategoryName = selectedCat ? selectedCat.name : '兰台研读';

            this.volumeList = [];
            this.teachingPlanList = [];
            this.coursePlanningList20 = [];
            this.coursePlanningList40 = [];
            this.coursePlanningList60 = [];
            this.courseVideoList = [];
            this.expertList = [];
            this.facultyList = [];
            this.totalItems = 0;

            try {
                if (this.selectedCategoryName === '教学计划') {
                    const response = await getTeachingProgram({});
                    if (response && response.code === 200) {
                        this.teachingPlanList = response.rows;
                        this.totalItems = response.total;
                    } else {
                        console.error('Failed to fetch teaching plan:', response.msg);
                    }
                } else if (this.selectedCategoryName === '课程规划') {
                    const response = await getCoursePlanningDalist({});
                    if (response && response.code === 200 && response.rows && response.rows.length > 0) {
                        response.rows.forEach(item => {
                            if (item.type === '1' && item.ltCoursePlanningDaList) {
                                this.coursePlanningList20 = item.ltCoursePlanningDaList;
                            } else if (item.type === '2' && item.ltCoursePlanningDaList) {
                                this.coursePlanningList40 = item.ltCoursePlanningDaList;
                            } else if (item.type === '3' && item.ltCoursePlanningDaList) {
                                this.coursePlanningList60 = item.ltCoursePlanningDaList;
                            }
                        });
                        this.totalItems = this.coursePlanningList20.length + this.coursePlanningList40.length + this.coursePlanningList60.length;
                    } else {
                        console.error('Failed to fetch course planning or response is empty:', response);
                    }
                } else if (this.selectedCategoryName === '课 程') {
                    // 使用新的API接口
                    const response = await getMaterialListAPI({ 
                        majorId: 47, 
                        pageNum: pageNum, 
                        pageSize: this.itemsPerPage 
                    });
                    if (response && response.code === 200) {
                        this.courseVideoList = response.rows;
                        this.totalItems = response.total;
                    } else {
                        console.error('Failed to fetch course videos:', response.msg);
                    }
                } else if (this.selectedCategoryName === '专 家') {
                    const response = await getSpecialist({});
                    if (response && response.code === 200) {
                        this.expertList = response.rows;
                        this.totalItems = response.total;
                    } else {
                        console.error('Failed to fetch experts:', response.msg);
                    }
                } else if (this.selectedCategoryName === '师 资') {
                    const response = await getTeachers({});
                    if (response && response.code === 200) {
                        this.facultyList = response.rows;
                        this.totalItems = response.total;
                    } else {
                        console.error('Failed to fetch faculty:', response.msg);
                    }
                } else {
                    const response = await getProjectList({ type: type, pageNum: pageNum, pageSize: this.itemsPerPage });
                    if (response && response.code === 200) {
                        this.volumeList = response.rows;
                        this.totalItems = response.total;
                    } else {
                        console.error('Failed to fetch volumes:', response.msg);
                    }
                }
            } catch (error) {
                if (this.selectedCategoryName === '教学计划') {
                    this.teachingPlanList = [];
                } else if (this.selectedCategoryName === '课程规划') {
                    this.coursePlanningList20 = [];
                    this.coursePlanningList40 = [];
                    this.coursePlanningList60 = [];
                } else if (this.selectedCategoryName === '课 程') {
                    this.courseVideoList = [];
                } else if (this.selectedCategoryName === '专 家') {
                    this.expertList = [];
                } else if (this.selectedCategoryName === '师 资') {
                    this.facultyList = [];
                } else {
                    this.volumeList = [];
                }
                this.totalItems = 0;
                console.error('Error fetching data:', error);
            }
        },
        goToPage(page) {
            if (this.selectedCategoryName !== '教学计划' && this.selectedCategoryName !== '课程规划' && this.selectedCategoryName !== '课 程' && this.selectedCategoryName !== '专 家' && this.selectedCategoryName !== '师 资') {
                if (page >= 1 && page <= this.totalPages) {
                    this.fetchVolumes(this.selectedCategory, page);
                }
            }
        },
        viewCourseVideoDetail(video) {
            // 检查用户是否已登录 - 直接从store.state获取token
            const token = this.$store.state.token;
            if (!token) {
                // 用户未登录，显示登录弹窗
                this.showAuthDialog = true;
                return;
            }
            
            // 直接跳转到详情页，由详情页处理购买状态和试看逻辑
            this.$router.push({
                path: '/course-resource-detail',
                query: {
                    resource: encodeURIComponent(JSON.stringify(video))
                }
            });
        },
        handleLoginSuccess() {
            // 登录成功后关闭弹窗
            this.showAuthDialog = false;
        },
        viewVolumeDetail(volume) {
            this.$router.push({
                path: '/details',
                query: {
                    from: 'volume',
                    item: encodeURIComponent(JSON.stringify(volume))
                }
            });
        },
        viewExpertDetail(item, type) {
            // 提取需要的数据字段
            const expertData = {
                id: item.id,
                name: item.name,
                photograph: item.photograph,
                honor: item.honor,
                introduce: item.introduce,
                position: item.position,
                remark: item.remark,
                unit: item.unit,
                createTime: item.createTime,
                modifyTime: item.modifyTime
            };

            console.log('Passing data:', expertData);
            this.$router.push({
                path: '/expert-detail',
                query: {
                    data: JSON.stringify({
                        total: this.totalItems,
                        code: 200,
                        msg: "查询成功",
                        rows: [expertData]
                    }),
                    type: type
                }
            });
        }
    },
    computed: {
        totalPages() {
            if (this.selectedCategoryName === '教学计划' || this.selectedCategoryName === '课程规划' || this.selectedCategoryName === '课 程' || this.selectedCategoryName === '专 家' || this.selectedCategoryName === '师 资') {
                return 1;
            }
            return Math.ceil(this.totalItems / this.itemsPerPage);
        }
    }
}
</script>

<style scoped>
.main-image {
    width: 79.17%;
    max-width: 1520px;
    height: auto;
    display: block;
    margin: 0 auto;
}

.news-container {
    display: flex;
    padding: 20px;
    max-width: 1200px;
    margin: 20px auto;
    margin-top: -50px;
    flex-direction: column;
}

.news-intro-card {
    background: white;
    border-radius: 12px;
    padding: 32px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.news-intro-card .card-title {
    color:#ac6249;
    font-size: 24px;
    margin-bottom: 16px;
    padding-bottom: 8px;
    position: relative;
    display: inline-block;
}

.news-intro-card .card-title::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color:#ac6249;
}

.news-intro-card .english-subtitle {
    font-size: 20px;
    color:#b4715b;
    font-weight: normal;
}

.news-content-area {
    display: flex;
    gap: 40px;
    margin-top: 20px;
}

.news-sidebar {
    width: 200px;
}

.news-sidebar ul {
    list-style: none;
    padding: 0;
}

.news-sidebar li {
    cursor: pointer;
    padding: 10px 15px;
    margin-bottom: 10px;
    background-color: #eab58b;
    color: white;
    border-radius: 4px;
    transition: background-color 0.3s ease, opacity 0.3s ease;
    text-align: center;
}

.news-sidebar li:hover {
    background-color:#ac6249;
    opacity: 0.9;
}

.news-sidebar li.active {
    background-color: #ac6249;
    font-weight: bold;
}

.news-content {
    flex-grow: 1;
}

.article-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}

.article-item {
    border: 1px solid #eee;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
}

.article-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.article-image {
    width: 100%;
    height: 160px;
    object-fit: cover;
}

.article-info {
    padding: 15px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.article-date {
    font-size: 0.8em;
    color: #666;
    margin-bottom: 8px;
}

.article-title {
    font-size: 1em;
    margin-top: 0;
    margin-bottom: 0;
    color: #333;
    flex-grow: 1;
}

.pagination {
    margin-top: 20px;
    text-align: center;
}

.pagination button {
    margin: 0 5px;
    padding: 8px 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.pagination button:hover:not(:disabled) {
    background-color: #f0f0f0;
}

.pagination button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.pagination button.active {
    background-color: #ac6249;
    color: white;
    border-color: #ac6249;
}

.teaching-plan-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

.teaching-plan-table th,
.teaching-plan-table td {
    border: 1px solid #ddd;
    padding: 12px;
    text-align: left;
}

.teaching-plan-table th {
    background-color: #ac6249;
    color: white;
}

.teaching-plan-table tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

.teaching-plan-table tbody tr:hover {
    background-color: #ddd;
}

.course-planning-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

.course-planning-table th,
.course-planning-table td {
    border: 1px solid #ddd;
    padding: 12px;
    text-align: left;
}

.course-planning-table th {
    background-color: #ac6249;
    color: white;
}

.course-planning-table tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

.course-planning-table tbody tr:hover {
    background-color: #ddd;
}

h4 {
    margin-top: 20px;
    margin-bottom: 10px;
    color: #333;
}

.course-video-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    /* Adjust column size as needed */
    gap: 20px;
}

.video-item {
    border: 1px solid #eee;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
}

.video-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.video-image {
    width: 100%;
    height: 120px;
    /* Adjust height as needed */
    object-fit: cover;
}

.video-info {
    padding: 10px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.video-title {
    font-size: 1em;
    margin: 0;
    color: #333;
}


/* Styles for expert and faculty grid, similar to video grid */
.expert-faculty-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    /* Adjust column size as needed */
    gap: 20px;
}

.item {
    border: 1px solid #eee;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
    /* Added cursor pointer for potential future click functionality */
}

.item:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.item-image {
    width: 100%;
    height: 150px;
    /* Adjust height as needed */
    object-fit: cover;
}

.item-info {
    padding: 10px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* Center name */
}

.item-title {
    font-size: 1em;
    margin: 0;
    color: #333;
    text-align: center;
    /* Center name */
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    .main-image {
        width: 100%;
    }

    .teaching-plan-table,
    .course-planning-table {
        display: block;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .teaching-plan-table th,
    .teaching-plan-table td,
    .course-planning-table th,
    .course-planning-table td {
        padding: 8px;
        font-size: 13px;
        min-width: 80px;
    }

    .article-grid {
        grid-template-columns: 1fr;
    }

    .news-container {
        padding: 15px;
        margin: 20px 10px;
        margin-top: -30px;
    }

    .news-intro-card {
        padding: 20px;
        border-radius: 8px;
    }

    .news-intro-card .card-title {
        font-size: 20px;
    }

    .news-intro-card .english-subtitle {
        font-size: 16px;
        display: block;
        margin-top: 5px;
    }

    .news-content-area {
        flex-direction: column;
        gap: 20px;
        margin-top: 15px;
    }

    .news-sidebar {
        width: 100%;
    }

    .news-sidebar h3 {
        font-size: 16px;
        margin-bottom: 10px;
    }

    .news-sidebar ul {
        display: flex;
        gap: 10px;
        overflow-x: auto;
        padding-bottom: 5px;
    }

    .news-sidebar li {
        min-width: 100px;
        flex-shrink: 0;
        padding: 8px 12px;
        margin-bottom: 0;
        font-size: 14px;
    }

    .news-content h3 {
        font-size: 18px;
        margin-bottom: 15px;
    }

    h4 {
        font-size: 16px;
        margin-top: 15px;
    }

    .teaching-plan-table,
    .course-planning-table {
        font-size: 12px;
        margin-top: 15px;
    }

    .teaching-plan-table th,
    .teaching-plan-table td,
    .course-planning-table th,
    .course-planning-table td {
        padding: 8px;
    }

    .course-video-grid {
        grid-template-columns: 1fr;
        gap: 15px;
    }

    .video-image {
        height: 180px;
    }

    .expert-faculty-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
    }

    .item-image {
        height: 120px;
    }

    .video-modal-content {
        max-width: 95%;
        max-height: 90%;
        padding: 15px;
    }

    .pagination button {
        padding: 6px 12px;
        font-size: 14px;
        margin: 0 3px;
    }
}

@media screen and (max-width: 480px) {
    .news-container {
        padding: 10px;
        margin: 15px 5px;
        margin-top: -20px;
    }

    .news-intro-card {
        padding: 15px;
    }

    .news-intro-card .card-title {
        font-size: 18px;
    }

    .news-intro-card .english-subtitle {
        font-size: 14px;
    }

    .teaching-plan-table,
    .course-planning-table {
        font-size: 11px;
    }

    .teaching-plan-table th,
    .teaching-plan-table td,
    .course-planning-table th,
    .course-planning-table td {
        padding: 6px;
    }

    .pagination button {
        padding: 5px 10px;
        font-size: 12px;
    }
}
</style>